module.exports = __webpack_public_path__ + "img/q3-6-active.6cf7ab7f.png";